import React from 'react'
import { useTranslation } from 'react-i18next';
import { Dropdown , Button , Icon} from 'semantic-ui-react';
import { useDispatch, useSelector } from "react-redux";
import { ChangeLang, ChangeIsRtl} from "../../../../redux/actions/mainActions"

const LanguageHandler = () => {
    const { i18n, t } = useTranslation();

    const langOptions = [
        {
          key: 'fa-IR',
          text: 'Fa',
          value: 'fa-IR',
          
        },
        {
          key: 'en-US',
          text: 'En',
          value: 'en-US',
        },
       
      ]
    const dispatch = useDispatch()
    const lang = useSelector((state)=>state.main.lang)
    const languageHandler = (e,data) => {
        i18n.changeLanguage(data.value);
        if (data.value === "fa-IR") {
          document.body.dir = "rtl";
          dispatch(ChangeIsRtl(true));
          dispatch(ChangeLang(data.value));
          localStorage.setItem("isRtl", 'true')
          localStorage.setItem("lang", 'fa-IR')
    
        } else {
          document.body.dir = "ltr";
          dispatch(ChangeIsRtl(false));
          dispatch(ChangeLang(data.value));
          localStorage.setItem("isRtl", 'false')
          localStorage.setItem("lang", 'en-US')
    
        }
    }
    return  <Button  className='w-100 btn-transparent d-flex flex-column align-items-center justify-content-center '>
    <Icon color='red' className='m-05 font-20px'  name='world'/>
    <Dropdown
                inline
                options={langOptions}
                defaultValue={lang}
                onChange={(e,data)=>languageHandler(e,data)}
                />
</Button>
    
    
}
export default LanguageHandler